import "react-app-polyfill/ie11";
import "react-app-polyfill/stable";
import React from "react";
import ReactDOM from "react-dom/client";
import "./registerStencilComponents";
import App from "./App";

/**
 * Comment in to activate Mock Service Worker.
 */
// import { worker } from "./mocks/browser";
// if (process.env.NODE_ENV === "development") {
//   worker.start({ onUnhandledRequest: "bypass" });
// }

const root = ReactDOM.createRoot(
  document.getElementById("password-reset") as HTMLElement,
);
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
